/* Patırtı mobil sepet çekmecesi: sepet sayfasının (main-cart) markup'ını Section Rendering API ile getirip
   drawer-panel içine yerleştirir. Adet / silme / indirim kodu ve her değişiklik sonrası yeniden çizim cart.js'teki
   <cart-page> elemanı tarafından yapılır (sepet sayfasıyla aynı kod). Yalnız ≤767px'te devreye girer. */
(function () {
  'use strict';
  if (window.__patirtiCartDrawer) return;
  window.__patirtiCartDrawer = true;
  const P = window.Patirti = window.Patirti || {};
  const mobile = window.matchMedia('(max-width: 767px)');
  const rootNode = () => document.querySelector('[data-cart-drawer]');
  const panelNode = () => { const root = rootNode(); return root && root.querySelector('drawer-panel'); };
  let loaded = false;
  let loading = null;

  const isActive = () => {
    const root = rootNode(), panel = panelNode();
    return Boolean(root && panel && root.dataset.enabled === 'true' && mobile.matches && typeof panel.open === 'function');
  };
  const cartPath = () => {
    const root = rootNode();
    try { return new URL((root && root.dataset.cartUrl) || '/cart', location.origin).pathname.replace(/\/$/, ''); } catch (_) { return '/cart'; }
  };
  const setCount = count => {
    const root = rootNode(), node = root && root.querySelector('[data-cart-drawer-count]');
    if (node && root.dataset.strCount) node.textContent = root.dataset.strCount.replace('__COUNT__', String(Number(count) || 0));
  };

  async function load(force) {
    const root = rootNode();
    if (!root) return;
    const body = root.querySelector('[data-cart-drawer-body]');
    if (loading) return loading;
    if (loaded && !force) {
      const page = body.querySelector('cart-page');
      if (page && typeof page.scheduleRefresh === 'function') page.scheduleRefresh();
      return;
    }
    loading = (async () => {
      body.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(root.dataset.sectionUrl, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = doc.querySelector('cart-page');
        if (!page) throw new Error('markup');
        page.querySelectorAll('script').forEach(node => node.remove());
        body.replaceChildren(document.importNode(page, true));
        loaded = true;
      } catch (_) {
        const template = root.querySelector('[data-cart-drawer-error]');
        body.replaceChildren(template ? template.content.cloneNode(true) : document.createTextNode(''));
        loaded = false;
      } finally {
        clearTimeout(timer);
        body.removeAttribute('aria-busy');
        loading = null;
      }
    })();
    return loading;
  }

  function open(trigger) {
    if (!isActive()) return false;
    const panel = panelNode();
    if (!panel.hasAttribute('open')) panel.open(trigger || null);
    load(false);
    return true;
  }
  function close() { const panel = panelNode(); if (panel && panel.hasAttribute('open')) panel.close(); }

  P.cartDrawer = { isActive, open, close, load };

  /* Header sepet simgesi, alt çubuk "Sepetim", hatırlatıcı/bildirim bağlantıları → çekmece. */
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-cart-drawer-open], .site-header a[href], .cart-reminder a[href], .side-toast a[href]');
    if (!link || !isActive()) return;
    if (!link.hasAttribute('data-cart-drawer-open')) {
      let url;
      try { url = new URL(link.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== cartPath() || url.search) return;
    }
    event.preventDefault();
    open(link);
  });

  document.addEventListener('cart:added', () => { if (isActive()) open(null); });
  document.addEventListener('cart:updated', event => {
    const cart = event.detail && (event.detail.cart || event.detail);
    if (cart && typeof cart.item_count !== 'undefined') setCount(cart.item_count);
  });
  const onMedia = () => { if (!mobile.matches) close(); };
  if (mobile.addEventListener) mobile.addEventListener('change', onMedia);
})();
